import React, {Component} from 'react';
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button
  } from 'reactstrap';



class Confirmar extends Component {

    txtConfirmar = (texto) =>{
        let text = '';
        if(texto===undefined || texto ===null || texto===''){
            text = 'Confirmar'
        }else {
            text = texto;
        }
        return text; 
    }

    colorBtn = (color) =>{
        let clr = '';
        if(color===undefined || color ===null || color===''){
            clr = 'primary'
        }else {
            clr = color;
        }
        return clr; 
    }

    render(){
        const { isOpen, toggle, texto, funcion, textoConfirmar, colorBtn} = this.props; 
        return (

            <Modal  isOpen={isOpen} toggle={toggle}   backdrop="static">
                <ModalBody style={{paddingTop:28}}>     
                    <span className="texto-confirmar">{texto}</span> 
                </ModalBody>
                <ModalFooter>
                    <Button  outline color="danger" size="sm" onClick={toggle} >Cancelar</Button>
                    <Button color={this.colorBtn(colorBtn)} size="sm" onClick={()=>{toggle(); funcion()}}>{this.txtConfirmar(textoConfirmar)}</Button>
                </ModalFooter>
            </Modal>

        )
    }
};

export default Confirmar;